import type { DisplayGroupLayout } from './displayGroupLayout'

export type BoardMessageSlice = {
  id: string
  characters: number[][]
}

export const splitMessageForDisplayGroup = (
  characters: number[][],
  displayGroup: DisplayGroupLayout
): BoardMessageSlice[] => {
  const results: BoardMessageSlice[] = []
  let rowOffset = 0

  for (const rowOfBoards of displayGroup.boards) {
    const hasFlagshipInRow = rowOfBoards.some(board => !board.boardStyle.includes('note'))
    const boardHeight = !hasFlagshipInRow ? 3 : 6
    const rowCharacters = characters.slice(rowOffset, rowOffset + boardHeight)

    let colOffset = 0
    for (const board of rowOfBoards) {
      const boardWidth = board.boardStyle.includes('note') ? 15 : 22
      const offset = colOffset
      const boardChars = rowCharacters.map(line => line.slice(offset, offset + boardWidth))
      results.push({
        id: board.id,
        characters: boardChars
      })
      colOffset += boardWidth
    }

    rowOffset += boardHeight
  }

  return results
}

export const getBoardSliceFromParentMessage = (
  characters: number[][] | null | undefined,
  layout: DisplayGroupLayout,
  boardId: string
) => {
  if (!characters) return null
  return splitMessageForDisplayGroup(characters, layout).find(slice => slice.id === boardId) ?? null
}

export const charactersEqual = (left: number[][], right: number[][]) => {
  if (left.length !== right.length) return false
  return left.every((row, rowIndex) => {
    const otherRow = right[rowIndex]
    if (!otherRow || row.length !== otherRow.length) return false
    return row.every((value, columnIndex) => value === otherRow[columnIndex])
  })
}
